import styled from 'styled-components';
import { FunctionColor } from '@lux/core';
import { Color, Preset, Tag, Text } from '@lux/text';

export const Menu = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1001;
    background-color: ${FunctionColor.function0};
    border-bottom: 1px solid ${FunctionColor.function20};
    width: 100%;
    overflow: auto;
    max-height: 500px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const Wrapper = styled.div`
    max-width: 1208px;
    margin: 0px auto;
    padding-left: 20px;
    box-sizing: content-box;
`;

export const CategoryMenu = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    margin: 0px auto;
    padding: 16px 3% 16px calc(3% + 8px);
`;

export const HeadingCategory = styled(Text).attrs({ preset: Preset.S, tag: Tag.H3, bold: true })`
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    text-transform: capitalize !important;

    svg {
        margin-right: 8px;
        width: 20px;
        height: 20px;
    }

    &:hover {
        color: ${Color.primary};
        cursor: pointer;

        svg path {
            fill: ${Color.primary};
            cursor: pointer;
        }
    }
`;

export const Category = styled.li`
    margin-bottom: 6px;
    padding-left: 28px;
`;

export const CategoryText = styled(Text).attrs({ preset: Preset.S })`
    text-transform: capitalize !important;
    &:hover {
        color: ${Color.primary};
        cursor: pointer;
    }
`;

export const Button = styled.button`
    all: unset;
    cursor: pointer;
    display: inline-block;
    &:focus {
        outline: revert;
    }

    &:focus-visible {
        outline: revert;
    }
`;
